module.exports = __webpack_public_path__ + "static/media/video.0b4d8fb0.jpg";